import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const TestimonialsSection = styled.section`
  padding: 80px 0;
  background-color: #0A1535;
  color: white;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const TestimonialsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const TestimonialCard = styled(motion.div)`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '"';
    position: absolute;
    top: 10px;
    left: 20px;
    font-size: 5rem;
    opacity: 0.1;
    color: #00E5FF;
    font-family: Georgia, serif;
  }
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, transparent, #00E5FF, transparent);
  }
`;

const TestimonialText = styled.p`
  font-style: italic;
  margin-bottom: 20px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const AuthorInfo = styled.div`
  margin-left: 15px;
`;

const AuthorName = styled.h4`
  margin: 0;
  font-size: 1.1rem;
  color: #00E5FF;
`;

const AuthorRole = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
`;

const AuthorAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #00E5FF;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #121E42;
  font-weight: bold;
  font-size: 1.2rem;
`;

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      id: 1,
      text: "A pós-graduação em Enfermagem em Cardiologia do Grupo Nobre transformou minha carreira. O conteúdo é atualizado e os professores são referências na área. Recomendo fortemente!",
      name: "Ana Paula Silva",
      role: "Enfermeira Especialista em UTI",
      initials: "AS"
    },
    {
      id: 2,
      text: "Fazer o MBA em Gestão em Saúde foi a melhor decisão que tomei. O networking e o conhecimento adquirido me permitiram assumir um cargo de liderança no hospital onde trabalho.",
      name: "Carlos Eduardo Mendes",
      role: "Gestor Hospitalar",
      initials: "CM"
    },
    {
      id: 3,
      text: "A metodologia EAD do Grupo Nobre é excelente. Consegui conciliar meus plantões com os estudos e hoje sou referência em Estomaterapia na minha região. Valeu cada minuto investido!",
      name: "Juliana Ferreira",
      role: "Enfermeira Estomaterapeuta",
      initials: "JF"
    }
  ];

  return (
    <TestimonialsSection id="depoimentos">
      <div className="container">
        <SectionTitle>O que dizem nossos alunos</SectionTitle>
        <TestimonialsContainer>
          {testimonials.map((testimonial) => (
            <TestimonialCard 
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: testimonial.id * 0.1 }}
              viewport={{ once: true }}
            >
              <TestimonialText>"{testimonial.text}"</TestimonialText>
              <TestimonialAuthor>
                <AuthorAvatar>{testimonial.initials}</AuthorAvatar>
                <AuthorInfo>
                  <AuthorName>{testimonial.name}</AuthorName>
                  <AuthorRole>{testimonial.role}</AuthorRole>
                </AuthorInfo>
              </TestimonialAuthor>
            </TestimonialCard>
          ))}
        </TestimonialsContainer>
      </div>
    </TestimonialsSection>
  );
};

export default Testimonials;
